var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.27148C7.73357 5.48355 7.00158 5.8173 6.33323 6.26388C5.09986 7.08799 4.13856 8.25933 3.57091 9.62978C3.00325 11.0002 2.85472 12.5082 3.14411 13.9631C3.4335 15.4179 4.14781 16.7543 5.1967 17.8032C6.2456 18.8521 7.58197 19.5664 9.03683 19.8558C10.4917 20.1452 11.9997 19.9967 13.3701 19.429C14.7406 18.8613 15.9119 17.9 16.736 16.6667C17.0845 16.1452 17.3642 15.585 17.5711 14.9999",
    stroke: "#7255E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C13.0506 3 14.0909 3.20693 15.0615 3.60896C16.0321 4.011 16.914 4.60028 17.6569 5.34315C18.3997 6.08602 18.989 6.96793 19.391 7.93853C19.7931 8.90914 20 9.94943 20 11L12 11L12 3Z",
    stroke: "#7255E3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/ChartIcon.643e23e9309c2b2df4a8927166310356.svg";
export { ForwardRef as ReactComponent };